import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import { useEffect, useState } from "react";
import Loader from "../../components/loader/Loader";
import Alerta from "../../components/alerta/Alerta";
import style from "./Frequencias.module.css";
import { Button, Form, Modal } from "react-bootstrap";
import { MdSearch, MdClose, MdSave } from "react-icons/md";
import FrequenciaApi from "../../services/FrequenciaApi";
import PessoaTurmaApi from "../../services/PessoaTurmaApi";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

function Frequencia() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);

    //Para rodar tabela e filtro
    const [buscaFiltro, setBuscaFiltro] = useState(false);
    const [frequencias, setFrequencias] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [turmaId, setTurmaId] = useState(0);
    const [dataPresenca, setDataPresenca] = useState(() => {
        const hoje = new Date();
        return hoje.toISOString().split("T")[0];
    });

    //Função para filtro de busca
    async function BuscarFrequencias() {
        setTurmaId(turmaId);
        setDataPresenca(dataPresenca);
        await BuscarFrequenciasFiltro();
        setBuscaFiltro(true);

    }

    //Função para resetar  filtro de busca
    async function ResetarFrequencias() {
        setTurmaId(0);
        setDataPresenca(() => {
            const hoje = new Date();
            return hoje.toISOString().split("T")[0];
        });
        setFrequencias([]);
        setBuscaFiltro(false);
    }

    // Função para extrair o horário de um datetime
    const formatarHora = (datetime) => {
        const date = new Date(datetime);
        return date.toTimeString().slice(0, 5);
    };

    // Função para montar o datetime com o dia atual + hora digitada
    const MudarHoraParaData = (index, campo, horaDigitada) => {
        if (!horaDigitada) {  // Se estiver vazio, setar null no campo e sair
            const novaLista = [...frequencias];
            novaLista[index][campo] = null;
            setFrequencias(novaLista);
            return;
        }

        const [horas, minutos] = horaDigitada.split(':');
        const data = new Date(dataPresenca); // Use a dataPresenca para manter a data correta
        data.setHours(Number(horas));
        data.setMinutes(Number(minutos));
        data.setSeconds(0);

        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        const hora = String(data.getHours()).padStart(2, '0');
        const minuto = String(data.getMinutes()).padStart(2, '0');
        const segundo = String(data.getSeconds()).padStart(2, '0');

        const dataHoraLocal = `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}`;

        const novaLista = [...frequencias];
        novaLista[index][campo] = dataHoraLocal;
        setFrequencias(novaLista);
    };

    const SalvarFrequencias = async () => {
        try {
            // const frequenciasValidas = frequencias.filter(f => f.pessoaId && f.pessoaId > 0);
            await FrequenciaApi.adicionarFrequenciasAsync(turmaId, dataPresenca, frequencias);
            setMensagemAlerta(`Frequencias salvas com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao salvar frequência: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        }
        finally {

        }
    }

    const BuscarFrequenciasFiltro = async () => {
        try {
            setFrequencias([]);
            const listaFrequencias = await FrequenciaApi.listarInformacoesFrequenciasAsync(turmaId, dataPresenca);
            setFrequencias(listaFrequencias);
        } catch (error) {
            console.error("Erro ao listar frequencias", error.response.data);
        }
    }

    const BuscarTurmasPorPessoa = async () => {
        try {
            const listaTurmas = await PessoaTurmaApi.listarTurmasPorPessoaAsync();
            setTurmas(listaTurmas);

        } catch (error) {
            console.error("Nenhuma turma encontrada");
        }
    }

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    useEffect(() => {
        BuscarTurmasPorPessoa();

    }, []);

    useEffect(() => {
        setFrequencias([]);
        setBuscaFiltro(false);
    }, [turmaId, dataPresenca]);

    const avancarDia = () => {
        const hoje = new Date();
        const dataAtual = new Date(dataPresenca);

        const proximoDia = new Date(dataAtual);
        proximoDia.setDate(proximoDia.getDate() + 1);

        if (proximoDia > hoje) return;

        setDataPresenca(proximoDia.toISOString().split("T")[0]);
        setBuscaFiltro(false);

    };

    const voltarDia = () => {
        const data = new Date(dataPresenca);
        data.setDate(data.getDate() - 1);
        setDataPresenca(data.toISOString().split("T")[0]);
        setBuscaFiltro(false);
    };


    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Frequência</h4>
                    </div>

                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>

                        <Form.Select
                            id="hidenTumra"
                            name="Turma"
                            value={turmaId}
                            onChange={(e) => {
                                setTurmaId(e.target.value);
                                setBuscaFiltro(false); // oculta a tabela ao trocar a turma
                            }}
                        >

                            <option value="">Selecione uma turma</option>
                            {turmas.map((turma) => (
                                <option key={turma.turmaId} value={turma.turmaId}>
                                    {turma.nome}
                                </option>
                            ))}
                        </Form.Select>
                        <div style={{ display: "flex", alignItems: "center"}}>
                            <Button variant="light" onClick={voltarDia}> <IoIosArrowBack /> </Button>
                            <Form.Control
                                type="date"
                                id="hidenDataPresenca"
                                placeholder="Data de presença"
                                name="dataPresenca"
                                value={dataPresenca}
                                onChange={(e) => {
                                    setDataPresenca(e.target.value);
                                    setBuscaFiltro(false); // oculta a tabela ao trocar a data
                                }}
                                max={new Date().toISOString().split('T')[0]}
                            />
                            <Button variant="light" onClick={avancarDia}> <IoIosArrowForward /> </Button>
                            </div>
                            <div className={style.container_filtro2} >
                                <Button onClick={BuscarFrequencias} id={style.botao_buscar} disabled={!turmaId || !dataPresenca}>
                                    <MdSearch /> Buscar
                                </Button>

                                <Button onClick={ResetarFrequencias} id={style.botao_resetar} disabled={!turmaId || !dataPresenca}>
                                    <MdClose /> Limpar
                                </Button>
                            </div>

                        </div>
                        {buscaFiltro && <div className={style.container_tabela_paginacao}>
                            <div className={style.tabela_responsiva}>
                                <table className={style.container_tabela}>
                                    <thead>
                                        <tr>
                                            <th>Nome Completo</th>
                                            <div className={style.hora_cabecalho}>
                                                <th>Entrada</th>
                                                <th>Saída</th>
                                            </div>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {frequencias.map((frequencia, index) => (
                                            <tr className={style.tabela_corpo} key={frequencia.frequenciaID}>
                                                <td title={frequencia.nomeCompleto}>{frequencia.nomeCompleto}</td>
                                                <div className={style.hora_corpo}>
                                                    <td>
                                                        <input
                                                            type="time"
                                                            className={style.inputHora}
                                                            value={frequencia.dataEntrada ? formatarHora(frequencia.dataEntrada) : ''}
                                                            onChange={(e) => MudarHoraParaData(index, 'dataEntrada', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="time"
                                                            className={style.inputHora}
                                                            value={frequencia.dataSaida ? formatarHora(frequencia.dataSaida) : ''}
                                                            onChange={(e) => MudarHoraParaData(index, 'dataSaida', e.target.value)}
                                                        />
                                                    </td>
                                                </div>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* Botão para marcar/desmarcar todos */}
                                <div className={style.botao_presenca}>
                                    <Button
                                        onClick={() => {
                                            frequencias.forEach((_, index) => {
                                                MudarHoraParaData(index, 'dataEntrada', '');
                                                MudarHoraParaData(index, 'dataSaida', '');
                                            });
                                        }}
                                        id={style.botao_marcar_todos}
                                    // style={{ backgroundColor: '#ff4444', color: 'white', marginLeft: '10px' }}
                                    >
                                        Limpar todos
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            frequencias.forEach((frequencia, index) => {
                                                // Encontra a turma correspondente à frequência
                                                const turma = turmas.find(t => t.turmaId === frequencia.turmaID);

                                                // Verifica o período da turma (2-Tarde, 3-Noite)
                                                const periodo = turma?.periodo;

                                                // Define os horários baseados no período
                                                const horarios = {
                                                    entrada: periodo === 3 ? '19:00' : '13:00', // Noite ou Tarde/Manhã
                                                    saida: periodo === 3 ? '22:30' : '17:00'    // Noite ou Tarde/Manhã
                                                };

                                                // Atualiza os horários

                                                // Só preenche se estiver vazio
                                                if (!frequencia.dataEntrada) {
                                                    MudarHoraParaData(index, 'dataEntrada', horarios.entrada);
                                                }
                                                if (!frequencia.dataSaida) {
                                                    MudarHoraParaData(index, 'dataSaida', horarios.saida);
                                                }
                                            });
                                        }}
                                        id={style.botao_marcar_todos}
                                    >
                                        Preencher todos
                                    </Button>

                                    <Button onClick={SalvarFrequencias} id={style.botao_salvar}>
                                        <MdSave /> Salvar
                                    </Button>
                                </div>
                            </div>
                        </div>}
                    </div>
            </Topbar>
        </Sidebar >
    );
}

export default Frequencia;
